import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';
import 'swiper/css/effect-creative';
import 'swiper/css/autoplay';

import { Navigation, Pagination, FreeMode, Thumbs, EffectCreative, Autoplay } from 'swiper/modules';

const ComponentHeroHome = () => {
    const progress = document.querySelector('.swiper-progress');
    const slides = document.querySelectorAll('[data-component="hero_home"] .slider_hero_home .swiper-slide');
    const numberOfSlides = slides.length;

    const swiperThumbConfig = {
        modules: [Navigation, Pagination, FreeMode, Thumbs, EffectCreative, Autoplay],
        slidesPerView: 1.35,
        watchSlidesProgress: true,
        allowTouchMove: false,
        spaceBetween: 2,
        speed: 600,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            0: {
                slidesPerView: 1.35,
                watchSlidesProgress: false,
                allowTouchMove: true,
            },
            640: {
                slidesPerView: 2,
                watchSlidesProgress: true,
                allowTouchMove: false,
            },
            1200: {
                slidesPerView: 3,
                watchSlidesProgress: true,
                allowTouchMove: false,
            },
        },
    };

    if (numberOfSlides === 2) {
        swiperThumbConfig.breakpoints[1200].slidesPerView = 2;
    }

    const swiperThumb = new Swiper('[data-component="hero_home"] .nav-slider', swiperThumbConfig);

    const swiper = new Swiper('[data-component="hero_home"] .slider_hero_home', {
        modules: [Navigation, Pagination, FreeMode, Thumbs, EffectCreative, Autoplay],
        loop: true,

        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },

        speed: 600,
        effect: 'creative',

        creativeEffect: {
            prev: {
                shadow: true,
                translate: ['-20%', 0, -1],
            },
            next: {
                translate: ['100%', 0, 0],
            },
        },
        navigation: {
            nextEl: '[data-component="hero_home"] .slider-button-next',
            prevEl: '[data-component="hero_home"] .slider-button-prev',
        },
        thumbs: {
            swiper: swiperThumb,
        },
        on: {
            init: function () {
                progress.classList.remove("animate");
                progress.classList.add("animate");
            },
            slideChangeTransitionStart: function () {
                progress.classList.remove("animate");
            },
            slideChangeTransitionEnd: function () {
                progress.classList.add("animate");
            }
        }
    });

    swiper.on('slideChange', function () {
        swiperThumb.slideTo(this.realIndex);
    });
};

export default ComponentHeroHome;
